import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=919cc660"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports